@if (tags()?.length > 0) {
  <div class="building-tags mb-2">
    @for (tag of tags(); track tag.tagId) {
      <cfp-badge [badgeStyle]="'light'" [classes]="'me-2'">{{ tag.tag }}</cfp-badge>
    }
  </div>
}
